import {Route, Routes} from 'react-router-dom';
import {UserLeaderboard} from './usersLeaderboard/UserLeaderboard';
import {SchemeUserLeaderboard} from './schemeUserLeaderboard/SchemeUserLeaderboard';

export const LeaderboardRoutes = () => {
  return (
    <Routes>
      <Route path="/" index element={<UserLeaderboard />} />
      <Route path="/scheme/:id" element={<SchemeUserLeaderboard />} />
    </Routes>
  );
};
